import { number, object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  type: string().oneOf(['database_import_records']).required(),
  status: string().oneOf(['completed', 'failed', 'in_progress', 'pending']).required(),
  success_count: number().required().integer().default(0),
  failure_count: number().required().integer().default(0),
  total_count: number().required().integer().default(0),
});

/**
 * BulkActionCreateEvent
 *
 * - Evento emitido quando uma ação em massa é criada.
 */
export class BulkActionCreateEvent extends CreateCommand(
  RealtimeEventType.BulkActionCreate,
  SCHEMA,
) {}
